import styled from "styled-components"
import React from "react"
import ReactDatePicker, { ReactDatePickerProps } from "react-datepicker"

const DatePickerWrapper = styled.div` // wraper to render all elements of DatePicker inside
    width: 100%;
`
const DatePickerStyled = styled(ReactDatePicker)`
    width: 100%;
    border: none;
    outline: none;
    padding: 6px 12px;
    margin-bottom: 8px;
    color: ${(props) => props.theme.inputColor};
    background: ${(props) => props.theme.inputBackground};

    &:focus {
        color: ${(props) => props.theme.inputFocusColor};
    }

    & + button {
        height: 33px;

        &::after {
            background: none;
            font-size: 24px;
            color: grey;
            transition: 0.1s ease;
        }

        &:hover::after {
            color: darkgrey;
            transition: 0.1s ease;
        }
    }
`

// eslint-disable-next-line import/prefer-default-export
export const DatePicker = (props: ReactDatePickerProps) => (
    <DatePickerWrapper>
        <DatePickerStyled popperPlacement="bottom-start" {...props} />
    </DatePickerWrapper>
)
